/*
 * エディット用mixin
 */
<script>
export default {
	computed: {
		REQUIRED_EMPTY_COL: function( ) {
			return "required_empty_col";
		},
		UPDATING_COL: function( ) {
			return "updating_col";
		},
	},
	methods: {
		/**
		 * エディットタイプ取得<br>
		 * for 必須項目エディット<br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 *
		 * @function  getEditClassType
		 * @returns result
		 * @instance
		 */
		getEditClassType: function( text, isChange ) {
			var className = "";
			if( isChange ) {
				className = this.UPDATING_COL;
				// 編集中
				if ( !text || text.length < 1){
					className = this.REQUIRED_EMPTY_COL;
				}
			} 
			return className;
		},
		// 必須項目エディット
		getEditClassType2: function( text, isChange ) {
			var className = "";
			if ( !text || text.length < 1){
				className = this.REQUIRED_EMPTY_COL;
			}
			else if( isChange ) {
				className = this.UPDATING_COL;
			} 
			return className;
		},
		//! 長さチェック
		getEditLengthClassType: function( text, isChange, minLen, maxLen ) {
			var className = "";
			if( isChange ) {
				className = this.UPDATING_COL;
			}
			// 編集中
			if ( text){
				if(text.length < minLen){
					className = this.REQUIRED_EMPTY_COL;
				}else if(text.length > maxLen){
					className = this.REQUIRED_EMPTY_COL;
				}
			}else{
				if(minLen >=0){
					className = this.REQUIRED_EMPTY_COL;
				}
			}
			className += " length-check-edit";
			return className;
		},
		/**
		 * 数値を比較しエディタータイプ取得<br>
         * for 必須項目エディット<br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 *
		 * @function  getNumClassType
		 * @returns result
		 * @instance
		 */
		getNumClassType: function( num, isChange ) {
			var className = "";
			if( isChange ) {
				className = this.UPDATING_COL;
				// 編集中
				if ( num == -2){
					className = this.REQUIRED_EMPTY_COL;
				}
			} 
			return className;
		},
		getNumEditClassType:function(text,isChange ) {
			var className = "";
			if ( !text || text.length==0){
				return this.REQUIRED_EMPTY_COL;
			}
			if( isChange ) {
				className = this.UPDATING_COL;
			} 
			return className;
		},
		getNumEmptyClassType: function( num, isChange ) {
			var className = "";
			if( isChange ) {
				className = this.UPDATING_COL;
			} 
			return className;
		},
		/**
		 * 必須ではないタイプ取得 <br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 * 一行編集画面で使用 <br>
		 *
		 * @function  getAnyEditClassType
		 * @returns result
		 * @instance
		 */
		getAnyEditClassType: function(text, isChange ) {
			if ( isChange ){
				return this.UPDATING_COL;
			}
			return "";
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/Edit2.mixin.vue